import SendMessageRequest from "../ws/SendMessageRequest";
import {I18nUtils} from "../../../../../../i18n/I18nUtils";
import Alert from "react-s-alert";
import MessageRequest from "../ws/MessageRequest";
import MarkReadMessagesRequest from "../ws/MarkReadMessagesRequest";

export const MESSAGE_DETAIL_UPDATE = 'message-detail-update';
export const MESSAGE_DETAIL_LOADING = 'message-detail-loading';
export const MESSAGE_DETAIL_ERROR = 'message-detail-error';
export const MESSAGE_DETAIL_MARK_AS_READ = 'message-detail-mark-as-read';
export const MESSAGE_DETAIL_ADD_RESPONSE = 'message-detail-add-response';

export const getMessage = (messageId) => (dispatch) => {

  new MessageRequest(messageId)
    .onPreExecution(() => {
      dispatch({ type: MESSAGE_DETAIL_LOADING, payload: true });
    })
    .onSuccess(data => {
      // Enviamos los datos a redux
      dispatch({
        type: MESSAGE_DETAIL_UPDATE,
        payload: data,
      });
    })
    .onFail(error => {
      dispatch({ type: MESSAGE_DETAIL_ERROR, payload: error });
    })
    .onPostExecution(() => {
      dispatch({ type: MESSAGE_DETAIL_LOADING, payload: false });
    })
    .execute();
};

export const markReadMessage = (messageId) => (dispatch) => {

  new MarkReadMessagesRequest(messageId)
    .onSuccess(data => {
      // Enviamos los datos a redux
      dispatch({
        type: MESSAGE_DETAIL_MARK_AS_READ,
        payload: messageId
      });
    })
    .execute();
};

export const responseMessage = (messageId, message, onSuccess = () => {}) => (dispatch) => {

  new SendMessageRequest(message, null, messageId)
    .onPreExecution(() => {
      dispatch({ type: MESSAGE_DETAIL_LOADING, payload: true });
    })
    .onSuccess(response => {
      dispatch({ type: MESSAGE_DETAIL_ADD_RESPONSE, id: messageId, payload: response.data });
      Alert.success(I18nUtils.tr('TR_SEND_MESSAGE_SUCCESS'));
      onSuccess();
    })
    .onFail(error => {
      Alert.error(error || I18nUtils.tr('TR_SEND_MESSAGE_ERROR'));
    })
    .onPostExecution(() => {
      dispatch({ type: MESSAGE_DETAIL_LOADING, payload: false });
    })
    .execute();
};




// WEBPACK FOOTER //
// ./src/app/messages-notifications/messages/to-refactor/shared/actions/messageDetailActions.js